import React, { useEffect } from "react";
import { PortfolioData } from "../types";
import { handleHashScroll } from "../utils/scrollToSection";
import SEO from "../components/SEO";

// Import the Header component for the home page
import Header from "../components/Header";

// Import the relevant sections to be displayed on the Home Page
import ContactSection from "../components/ContactSection";
import ExperienceSection from "../components/ExperienceSection";
import SkillsSection from "../components/SkillsSection";
import EducationSection from "../components/EducationSection";
import AwardsSection from "../components/AwardsSection";

interface HomePageProps {
  portfolioData: PortfolioData;
}

const HomePage: React.FC<HomePageProps> = ({ portfolioData }) => {
  useEffect(() => {
    handleHashScroll();
  }, []);

  return (
    <div className="home-page">
      <SEO
        title="Hardik Butani - Full stack Developer | Node.js, Nest.js, AWS Expert"
        description="Experienced Full stack Developer specializing in Node.js, Nest.js, AWS, and Full-Stack Development. 5+ years of experience building scalable APIs, microservices, and cloud solutions."
        keywords="Full stack Developer, Node.js Developer, Nest.js Developer, AWS Developer, Full-Stack Developer, API Development, Microservices, Cloud Computing, Software Engineer, Database Design, REST APIs, GraphQL, MongoDB, PostgreSQL, Docker, Kubernetes, CI/CD, GitHub Actions, Team Leadership, Ahmedabad, India"
        url="/"
        type="profile"
        tags={[
          "Backend Development",
          "Node.js",
          "Nest.js",
          "Rect.js",
          "Next.js",
          "AWS",
          "API Development",
          "Microservices",
          "Full-Stack Development",
        ]}
      />

      {/* Header/Hero Section */}
      <Header basics={portfolioData.basics} portfolioData={portfolioData} />

      {/* Main Content Sections */}
      <div className="main-content">
        <ContactSection basics={portfolioData.basics} />

        <ExperienceSection experience={portfolioData.experience} />

        <SkillsSection
          skills={portfolioData.skills as unknown as Record<string, string[]>}
        />

        <EducationSection education={portfolioData.education} />
        <AwardsSection awards={portfolioData.awards} />
      </div>
    </div>
  );
};

export default HomePage;
